import { NgModule } from '@angular/core';
import { ControlsAreaComponent } from './controls-area.component';
import { SubToolbarModule } from '@caslink/common-client/ng-app/sub-toolbar/sub-toolbar.module';
import { AreaMenuModule } from '@caslink/common-client/ng-app/area-menu/area-menu.module';
import { CommonModule } from '@angular/common';
import { FlexModule } from '@angular/flex-layout';
import { HardwareItemSyncLoadingAnimationModule } from '../hardware-item-sync-loading-animation/hardware-item-sync-loading-animation.module';

@NgModule({
    imports: [
        SubToolbarModule,
        AreaMenuModule,
        HardwareItemSyncLoadingAnimationModule,
        CommonModule,
        FlexModule
    ],
    declarations: [
        ControlsAreaComponent
    ]
})
export class ControlsAreaModule {
}
